import {TileSpread} from "../../../../components/Tile.tsx";
import {createFileRoute} from "@tanstack/react-router";
import {SupervisorBundleTile} from "../../../../inspector/InspectorBundleTile.tsx";
import {SuspenseDialog} from "../../../../components/SuspenseDialog.tsx";
import {PageBody, PageHeader, PageShell} from "../../../../routing/shell.tsx";
import {TopBar} from "../../../../components/TopBar.tsx";
import {Stack} from "@mui/joy";
import {useSupervisorBundles} from "../../../../supervise/supervise.tsx";

function SupervisorBundlePage() {
    const {id: venueId} = Route.useParams();
    // const bundlesTqrv = useFullBundlesNeedingSupervisor({venueId});
    const bundlesTqrv = useSupervisorBundles({venueId});

    if (bundlesTqrv.isPending) {
        return <SuspenseDialog message="fetching bundles needing supervisor"/>;
    }

    const bundles = bundlesTqrv.data;
    return <PageShell>
        <PageHeader>
            <Stack direction="column">
                <TopBar/>
            </Stack>
        </PageHeader>
        <PageBody>
            <TileSpread foods={bundles} estimatedHeight={200} Component={({food: vxb}) =>
                <SupervisorBundleTile ixb={vxb}/>}/>
        </PageBody>
    </PageShell>

}

export const Route = createFileRoute("/_auth/venue/$id/supervise/bundle")({
    component: SupervisorBundlePage,
});
